import axios from "axios";

// Use relative URLs so the app works when served from FastAPI directly
// (LAN, Cloudflare Tunnel, ngrok, any domain — no hardcoded localhost).
const BASE = "";

export const startDownload = (url) =>
  axios.post(`${BASE}/download`, { url }).then((r) => r.data);

export const getStatus = (jobId) =>
  axios.get(`${BASE}/status/${jobId}`).then((r) => r.data);

export const getResults = (jobId) =>
  axios.get(`${BASE}/results/${jobId}`).then((r) => r.data);

export const exportZipUrl = (jobId) => `${BASE}/export/${jobId}`;
